export default __webpack_public_path__ + "static/bfactory-logo-055d51349d0c89abafeaf15bf5bbe816.svg";